/**
 * Retorna o valor de background CSS baseado no layoutConfig.
 * Se type === "default" ou layoutConfig nulo, retorna null (usa padrão do template).
 */
export function getBackground(layoutConfig) {
  if (!layoutConfig?.background || layoutConfig.background.type === "default") return null;

  if (layoutConfig.background.type === "solid") {
    const { color = "#ffffff", opacity = 100 } = layoutConfig.background.solid ?? {};
    if (opacity >= 100) return color;
    const hex = color.replace("#", "");
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r},${g},${b},${(opacity / 100).toFixed(2)})`;
  }

  if (layoutConfig.background.type === "gradient") {
    const { direction = "to bottom", stops = [] } = layoutConfig.background.gradient ?? {};
    if (stops.length < 2) return null;
    const stopsStr = stops.map((s) => `${s.color} ${s.position}%`).join(", ");
    return `linear-gradient(${direction}, ${stopsStr})`;
  }

  return null;
}

const CIRCLE_SIZES = { P: 90, M: 140, G: 200 };
const SQUARE_SIZES = { P: 140, M: 220, G: 320 };

/**
 * Retorna os estilos inline para o elemento <img> da imagem de capa.
 * Retorna null se layoutConfig não definir coverImage.
 */
export function getCoverImageStyle(layoutConfig) {
  if (!layoutConfig?.coverImage) return null;
  const { shape = "circle", size = "M" } = layoutConfig.coverImage;
  const dim = shape === "circle" ? CIRCLE_SIZES[size] ?? CIRCLE_SIZES.M : null;
  const squareDim = SQUARE_SIZES[size] ?? SQUARE_SIZES.M;

  if (shape === "circle") {
    return { width: dim, height: dim, borderRadius: "50%", objectFit: "cover", display: "block" };
  } else {
    return { width: squareDim, maxWidth: "100%", height: "auto", borderRadius: 12, objectFit: "cover", display: "block" };
  }
}

/**
 * Retorna os estilos para o wrapper da imagem de capa.
 * Para círculo: div centralizado com dimensões fixas.
 * Para quadrado: div centralizado com maxWidth.
 */
export function getCoverImageWrapperStyle(layoutConfig) {
  if (!layoutConfig?.coverImage) return null;
  const { shape = "circle", size = "M" } = layoutConfig.coverImage;
  const dim = shape === "circle" ? CIRCLE_SIZES[size] ?? CIRCLE_SIZES.M : null;
  const squareDim = SQUARE_SIZES[size] ?? SQUARE_SIZES.M;

  if (shape === "circle") {
    return { width: dim, height: dim, borderRadius: "50%", overflow: "hidden", margin: "0 auto" };
  } else {
    return { width: squareDim, maxWidth: "100%", borderRadius: 12, overflow: "hidden", margin: "0 auto" };
  }
}

export const defaultLayoutConfig = {
  coverImage: { shape: "circle", size: "M" },
  background: {
    type: "default",
    solid: { color: "#ffffff", opacity: 100 },
    gradient: {
      direction: "to bottom",
      stops: [
        { color: "#ffffff", position: 0 },
        { color: "#cccccc", position: 100 },
      ],
    },
  },
  sections: { howToGet: true, address: true },
};

export function parseLayoutConfig(jsonString) {
  if (!jsonString) return null;
  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
}
